/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    disabled: PropTypes.bool,
    expanded: PropTypes.bool,
    type: PropTypes.oneOf([
        'text',
        'radio',
        'checkbox',
        'completion',
        'password',
        'select',
        'textarea',
        'toggle',
        'fileupload',
        'colorpicker',
        'choice-list',
    ]),
    textType: PropTypes.oneOf(['area', 'completion', 'search']),
    checkboxType: PropTypes.oneOf(['add-remove', 'small']),
    radioType: PropTypes.oneOf(['choice-list']),
};

const defaultProps = {
    ...commonDefaultProps,
    type: 'text',
    disabled: false,
    expanded: false,
};

const FormField = (props) => {
    const classNames = [
        'c-form-field',
        props.type ? `c-form-field__${props.type}` : '',
        props.type === 'text' && props.textType ? `c-form-field__text--${props.textType}` : '',
        props.type === 'checkbox' && props.checkboxType ? `c-form-field__checkbox--${props.checkboxType}` : '',
        props.type === 'radio' && props.radioType ? `c-form-field__radio--${props.radioType}` : '',
        props.expanded ? `c-form-field__${props.type}_expanded` : '',
        props.disabled ? `c-form-field__${props.type}--disabled` : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

FormField.propTypes = propTypes;

FormField.defaultProps = defaultProps;

export default FormField;
